<ng-container *transloco="let t">
  <div class="flex flex-col gap-2">
    <!-- Label -->
    @if (props.label) {
      <label [for]="id" class="font-semibold">
        {{ props.label }}
      </label>
    }

    <!-- WYSIWYG Display -->
    <div class="relative">
      <div
        class="wysiwyg-content p-3 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded min-h-[2.5rem] overflow-y-auto prose prose-sm max-w-none"
        [innerHTML]="sanitizedHtml"
      ></div>
    </div>
  </div>
</ng-container>
